export default __webpack_public_path__ + "static/media/radio-checked.9dc95440.svg";